// import { AddRoom } from "../layout/adminPanel/addRoom";
// import { BookingMailAdmin } from "../layout/adminPanel/bookingMailAdmin";
// import { NewsletterEmailList } from "../layout/adminPanel/newsLetterEmail";
// import { RoomFacility } from "../layout/adminPanel/roomFacility";

import { AddRoom } from "../../components/adminPanel/addRoom";
import { BookingMailAdmin } from "../../components/adminPanel/bookingMailAdmin";
import { NewsletterEmailList } from "../../components/adminPanel/newsLetterEmail";
import { RoomFacility } from "../../components/adminPanel/roomFacility";

export const HotelAdmin = () => {
  return (
    // <>
    //   <div className="accordion" id="">
    //     <AddRoom />
    //     <RoomFacility/>
    //   </div>
    // </>

    <>
      {/* <div class="accordion" id="accordionExample"> */}
      <div className="accordion" id="adminPanelRoomDetail">
        <AddRoom />
        <RoomFacility />
        <BookingMailAdmin />
        <NewsletterEmailList/>
      </div>
    </>
  );
};
